// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Address.module.scss  */
.Address-module-Root_FQ6 {
  max-width: max-content;
  font-family: var(--display-font-family); }
  .Address-module-Root_FQ6 .Address-module-DeliveryIcon_1pt {
    margin-right: 11px;
    color: var(--color-control-background-default); }

.Address-module-Label_3uG {
  display: flex;
  align-items: center;
  font-size: var(--address-font-size-label);
  font-weight: bold;
  line-height: var(--address-line-height-label); }

.Address-module-Delivery_3ap {
  display: flex;
  align-items: center;
  color: var(--color-control-placeholder); }
  .Address-module-Delivery_3apText {
    display: inline-flex;
    align-items: center;
    min-height: 1.5rem;
    font-size: var(--address-font-size);
    line-height: var(--address-line-height);
    white-space: pre; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Address/Address.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,uCAAuC,EAAE;EACzC;IACE,kBAAkB;IAClB,8CAA8C,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,iBAAiB;EACjB,6CAA6C,EAAE;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC,EAAE;EACzC;IACE,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mCAAmC;IACnC,uCAAuC;IACvC,gBAAgB,EAAE","sourcesContent":["/*  imported from Address.module.scss  */\n.Address-module-Root_FQ6 {\n  max-width: max-content;\n  font-family: var(--display-font-family); }\n  .Address-module-Root_FQ6 .Address-module-DeliveryIcon_1pt {\n    margin-right: 11px;\n    color: var(--color-control-background-default); }\n\n.Address-module-Label_3uG {\n  display: flex;\n  align-items: center;\n  font-size: var(--address-font-size-label);\n  font-weight: bold;\n  line-height: var(--address-line-height-label); }\n\n.Address-module-Delivery_3ap {\n  display: flex;\n  align-items: center;\n  color: var(--color-control-placeholder); }\n  .Address-module-Delivery_3apText {\n    display: inline-flex;\n    align-items: center;\n    min-height: 1.5rem;\n    font-size: var(--address-font-size);\n    line-height: var(--address-line-height);\n    white-space: pre; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
